module.exports = "<div class=\"container\">\r\n  <router-outlet></router-outlet>\r\n</div>"